import React from 'react';
import PageLayout from '../../layout/PageLayout';
import ReportRegionContent from '../../layout/ReportRegionContent';

const ReportRegionContentPage: React.FC = () => (
  <PageLayout>
    <ReportRegionContent />
  </PageLayout>
);

export default ReportRegionContentPage;
